// TechFala GMX: identifica conversa de grupo WhatsApp (mesmo critério do backend).
export const isWhatsAppGroupConversation = conversation => {
  const sender = conversation?.meta?.sender || {};
  const identifier = String(sender.identifier || '');
  const name = String(sender.name || '');

  return identifier.includes('@g.us') || /\(GROUP\)/i.test(name);
};
